/* eslint-disable array-callback-return */
import { CUSTOM_DROPDOWN_OPTIONS } from './constants';

/* This function answers the question, Does the partner pay for add-ons, or is it the customer's responsibility? */
export const isPartnerSubsidizedAddOn = ({ answer, sku }) =>
  answer.get('subsidizedToPartner') && !sku.get('subsidizingBasePriceOnly');

// DEVICE CATALOGING utils
// Get device make options
export const getDeviceMakeOptions = (question) => {
  return question.answers.map((a) => {
    return { value: a.id, label: a.text };
  });
};

// Get device model options
export const getDeviceModelOptions = ({ products, includeIDK }) => {
  if (products) {
    const modelOptions = products.answers.map((p) => {
      return { value: p.id, label: p.name };
    });
    // push custom options 'other' & 'idk'
    modelOptions.push(CUSTOM_DROPDOWN_OPTIONS.OTHER);
    if (includeIDK) {
      modelOptions.push(CUSTOM_DROPDOWN_OPTIONS.I_DONT_KNOW);
    }
    return modelOptions;
  }
  return null;
};

export const getSelectedModel = ({ questionAnswers, valueId }) => {
  const selectedModel = questionAnswers.find((a) => {
    if (!a.productQuestion) return false;
    return valueId === a.id && a.productQuestion.answers;
  });
  return selectedModel;
};

export const getModelQuestion = ({ answers }) => {
  if (!answers[0].productQuestion) return null;
  return answers[0].productQuestion.text;
};

export const getAnswerWarning = (q, val) => {
  if (!val || !q) return null;
  let hint = null;
  q.answers.find((answer) => {
    if (answer.id === val) {
      hint = answer.warning;
    }
  });
  return hint;
};

/*
  function to check if value is string - if it is, that means it is an input field.
*/
export const isStringType = (value) => typeof value === 'string';
